import { Component, Output, EventEmitter,
  Input, ViewEncapsulation, 
  OnInit,
  inject} from '@angular/core';
import { environment } from 'environments/environment';
import { Router } from '@angular/router';
import { LabUserMenuService } from 'app/services/lab-user-menu/lab-user-menu.service';
import { AuthService } from '@shared/auth/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { MsalBroadcastService } from '@azure/msal-angular';
import { filter } from 'rxjs';
import { EventMessage, EventType } from '@azure/msal-browser';
import { SettingsService } from 'app/services/core/settings.service';
import { SharedService } from '@shared/services/shared.service';

@Component({
  selector: 'app-navbar',
  host: {
    class: 'matero-header',
  },
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class NavbarComponent implements OnInit{
  public environment = environment;

  options = this.settings.getOptions();
  darkMode: boolean = this.options.theme === 'dark';
  // darkMode: boolean = false;
  @Input() isMobile = false;
  @Input() showToggle = true;
  @Output() toggleSidenav = new EventEmitter<void>();
  @Output() toggleChatbotNotice = new EventEmitter<void>();
  @Output() optionsChange = new EventEmitter<object>();

  // private authService = inject(AuthService);
  // public sharedService = inject(SharedService);
  // private msalBroadcastService =  inject(MsalBroadcastService);

  constructor(private settings: SettingsService,
              private sharedService: SharedService,
              private router: Router,
              private service: LabUserMenuService,
              private authService: AuthService,
              public dialog: MatDialog,
              private msalBroadcastService: MsalBroadcastService
              ) { 
  }

  ngOnInit(): void{
    this.msalBroadcastService.msalSubject$
    .pipe(
      filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS)
    )
    .subscribe(() => {
      this.toggleSidenav.emit();
    });

    if(this.authService.isAuthenticated()) {
      this.authService.loadUserInformation();
      this.sharedService.getUserTheme();
    }
  }

  toggleTheme() {
    this.darkMode = !this.darkMode;
    this.options.theme = this.darkMode ? 'dark' : 'light';
    this.settings.setTheme(this.options.theme);
    this.optionsChange.emit(this.options);
  }

  getUserName(): string {
    return sessionStorage.getItem('user');
  }

  authenticated(): boolean {
    return this.authService.isAuthenticated();
  }

  logout(): void {
    this.authService.logout();
  }
}
